export default "__VITE_ASSET__7c986304__"